import React from 'react';
import { TextAreaField } from 'components/forms';
import Tracker from 'tracker';
import ActiveButton from 'components/activeButton';

/* Max file size for an individual attachment is 3MB */
const MAX_FILE_SIZE = 3145728;

const propTypes = {
    onChange: React.PropTypes.func,
    onSubmit: React.PropTypes.func,
    onAttachmentsChange: React.PropTypes.func,
    saveButton: React.PropTypes.bool,
    attachments: React.PropTypes.array,
    message: React.PropTypes.string,
    error: React.PropTypes.string,
    actionLabel: React.PropTypes.string,
    submitLabel: React.PropTypes.string,
    rows: React.PropTypes.number,
};

const defaultProps = {
    onSubmit: () => {},
    onChange: () => {},
    onAttachmentsChange: () => {},
    saveButton: true,
    attachments: [],
    message: '',
    error: '',
    actionLabel: 'Sending',
    submitLabel: 'Send',
    rows: 5,
};

class NewMessage extends React.Component {
    constructor(props) {
        super(props);

        this.handleMessageChanged = this.handleMessageChanged.bind(this);
        this.handleAttachmentsClick = this.handleAttachmentsClick.bind(this);
        this.handleAttachmentsChanged = this.handleAttachmentsChanged.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        this.tracker = new Tracker();
        this.state = {
            saving: props.saving || false,
            newMessage: props.message,
            newMessageError: props.error,
            attachments: props.attachments,
        };
    }

    componentWillReceiveProps(nextProps) {
        const newState = { saving: nextProps.saving };
        if (nextProps.error && nextProps.error !== this.state.newMessageError) {
            newState.newMessageError = nextProps.error;
        }

        this.setState(newState);
    }


    handleMessageChanged(value) {
        this.setState({ newMessage: value }, () => {
            this.props.onChange(value);
        });
    }

    handleAttachmentsClick() {
        this.refs.files.click();
    }

    handleAttachmentsChanged(e) {
        let processedCount = 0;
        const filesWithErrors = [];
        const attachments = this.state.attachments;
        const uploadedCount = e.target.files.length;

        if ((uploadedCount + attachments.length) > 10) {
            this.setState({ newMessageError: 'You can only attach up to 10 files per message.' });
            return;
        }

        const onLoad = (file, upload) => {
            processedCount += 1;
            attachments.push({
                id: Math.random(),
                data_uri: upload.target.result,
                filename: file.name,
                filetype: file.type,
            });
        };

        const onLoadStart = (reader, file, upload) => {
            if (upload.lengthComputable && upload.total > MAX_FILE_SIZE) {
                processedCount += 1;
                filesWithErrors.push(file.name);
                reader.abort();
            }
        };

        const onLoadEnd = () => {
            if (processedCount !== uploadedCount) {
                return;
            }

            let errorMessage = '';
            if (filesWithErrors.length > 1) {
                errorMessage = 'Files ' + filesWithErrors.join(', ') + ' must be less than 3MB in size.';
            } else if (filesWithErrors.length === 1) {
                errorMessage = 'File ' + filesWithErrors[0] + ' must be less than 3MB in size.';
            }

            this.setState({ attachments: attachments, newMessageError: errorMessage }, () => {
                this.props.onAttachmentsChange(this.state.attachments, this.state.newMessageError);
            });
        };

        for (let i = 0; i < e.target.files.length; i += 1) {
            const file = e.target.files[i];
            const reader = new FileReader();

            reader.onload = onLoad.bind(this, file);
            reader.onloadstart = onLoadStart.bind(this, reader, file);
            reader.onloadend = onLoadEnd.bind(this);
            reader.readAsDataURL(file);
        }
    }

    handleRemoveAttachment(name) {
        let index = null;

        this.state.attachments.forEach((attachment, i) => {
            if (attachment.filename === name) {
                index = i;
            }
        });

        if (index !== null) {
            const attachments = this.state.attachments;
            attachments.splice(index, 1);

            this.setState({ attachments: attachments, newMessageError: '' }, () => {
                this.props.onAttachmentsChange(this.state.attachments);
            });
        }
    }

    handleSubmit(e) {
        e.preventDefault();

        if (!this.state.newMessage) {
            this.setState({ newMessageError: 'Please provide a message to send.' });

            return;
        }

        this.props.onSubmit({
            newMessage: this.state.newMessage,
            attachments: this.state.attachments,
        }, () => {
            this.setState({ newMessage: '', attachments: [], newMessageError: '' });
        }, (error) => {
            this.setState({ newMessageError: error });
        });
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className={`new-message-field` + (this.state.newMessageError ? ' has-error' : '')}>
                    <TextAreaField
                        key="body"
                        rows={this.props.rows}
                        placeholder="Type message..."
                        value={this.state.newMessage}
                        onChange={this.handleMessageChanged}
                    />

                    <div className="attachments">
                        {this.state.attachments.length > 0 && <div className="attachment-list">
                            <strong>Attachments:</strong>
                            {this.state.attachments.map((attachment) => {
                                return (
                                    <span key={`new-attachment-${attachment.id}`} className="attachment">
                                        {attachment.filename}
                                        <a className="remove-attachment" onClick={this.handleRemoveAttachment.bind(this, attachment.filename)}>
                                            <span className="fa fa-trash" />
                                        </a>
                                    </span>
                                );
                            })}
                        </div>}
                        <div className="icon" onClick={this.handleAttachmentsClick} />
                        <input type="file" ref="files" onChange={this.handleAttachmentsChanged} multiple={true} />
                    </div>

                    {this.state.newMessageError && <p className="help-block">{this.state.newMessageError}</p>}
                </div>

                {this.props.saveButton && <ActiveButton
                    saving={this.state.saving}
                    actionLabel={this.props.actionLabel}
                    submitLabel={this.props.submitLabel}
                />}
            </form>
        );
    }
}

NewMessage.propTypes = propTypes;
NewMessage.defaultProps = defaultProps;

export default NewMessage;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/events/newMessage.jsx